const $ = jQuery.noConflict();

function clickFocus() {

    $(document).on("click", "[data-clickfocus]", function () {
        const selector = $(this).attr("data-clickfocus");
        const elementToFocus = $(document).find(selector);

        if (elementToFocus.length) {
            //console.log("Direct focus applied");
            elementToFocus.get(0).focus();
        } else {
            //console.log("Waiting for htmx swap to apply focus");

            document.addEventListener("htmx:afterSwap", function handleSwap(event) {
                const elementToFocus = $(selector);

                if (elementToFocus.length) {
                    setTimeout(() => {
                        //console.log("Focus applied after htmx swap");
                        elementToFocus.get(0).focus();
                    }, 10);
                    document.removeEventListener("htmx:afterSwap", handleSwap);
                }
            });
        }
    });

}

function lazyImages() {

    window.lazySizesConfig = window.lazySizesConfig || {};
    lazySizesConfig.expand = 1500;
    lazySizesConfig.loadHidden = false;
}

function flickity() {

    $('.c-card__carousel').flickity({
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        wrapAround: true,
        "imagesLoaded": true
    });

    $('.c-carousel').flickity({
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        autoPlay: 5000,
        wrapAround: true,
        "imagesLoaded": true
    });

    $('.c-carousel--activities').flickity({
        // options
        cellAlign: 'center',
        contain: true,
        pageDots: true,
        autoPlay: 3000,
        wrapAround: true,
        "imagesLoaded": true,
        prevNextButtons: false
    });

    $('.c-carousel--categories').flickity({
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        wrapAround: false,
        freeScroll: true,
        "imagesLoaded": true
    });

    $('.c-carousel-badges').flickity({
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        autoPlay: 5000,
        wrapAround: true,
        "imagesLoaded": true
    });
    
}

function flickityFeedResize() {
    if ($('.c-feed__view-switcher').length > 0) {
        $('.c-feed__view-switcher label').on('click', function () {
            $('.c-card__carousel').flickity('resize');
            $('.c-carousel--activities').flickity('resize');
        });
    }
}

function matchHeight() {

    $('.js-match-height').matchHeight();
    $('.js-match-height-card').matchHeight();
    
}

function customScrollbar() {

    Array.prototype.forEach.call(
        document.querySelectorAll('.js-custom-scrollbar'),
        (el) => new SimpleBar(el)
    );

    $('.js-search').on('focus', function() {
        Array.prototype.forEach.call(
            document.querySelectorAll('.tt-menu'),
            (el) => new SimpleBar(el)
        );
    });

    $('#searchAddress').on('focus', function() {
        Array.prototype.forEach.call(
            document.querySelectorAll('.tt-menu'),
            (el) => new SimpleBar(el)
        );
    });
    
}

function datepicker() {

    $( '.js-datepicker' ).datepicker({
        orientation: "bottom auto",
        autoclose: true,
        language: is.culture
    });

    var dateMinus25Years = new Date();
    dateMinus25Years.setFullYear(dateMinus25Years.getFullYear() - 25);

    $('.js-datepicker-dob').datepicker({
        orientation: "bottom auto",
        autoclose: true,
        language: is.culture,
        defaultViewDate: {
            year: dateMinus25Years.getFullYear(),
            month: dateMinus25Years.getMonth(),
            day: dateMinus25Years.getDate()
        },
        defaultDate: dateMinus25Years,
        setDate: dateMinus25Years
    });

}

function select2() {

    $('.js-select').select2();
    
}

function magnificPopup() {

    $('.c-carousel-popup').magnificPopup({
        type: 'image',
        disableOn: 576,
        gallery:{enabled:true},
        closeOnContentClick: true
    });

}

function magnificPopupResize() {
    if( $('.c-carousel-popup').length > 0 ) {
        if( $(window).width() < 600 ) {
            $('.c-carousel-popup').on('click', function() {
                return false;
            });
        }
    }
}


function tooltips() {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(t => new bootstrap.Tooltip(t));

    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
    const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))

    // Close the popover when clicking outside
    document.addEventListener('click', function (e) {
        var popovers = document.querySelectorAll('.popover');

        if (popovers.length > 0) {
            popovers.forEach(function (popoverElement) {
                if (popoverElement.classList.contains('show')) {
                    if (!popoverElement.contains(e.target)) {
                        popoverElement.classList.remove('show');
                        $(document).find('.popover').hide();
                    }
                }
            });
        }
    });

    document.addEventListener('mouseover', function (e) {
        if (e.target.closest('[data-bs-toggle="popover"]')) {
            e.target.click();
        }
    });
}

$(function () {
    clickFocus();
    lazyImages();
    flickity();
    flickityFeedResize();
    matchHeight();
    customScrollbar();
    datepicker();
    select2();
    magnificPopup();
    magnificPopupResize();
    tooltips();
});

$(window).on("resize", magnificPopupResize);

window.flickity = flickity;